module.exports = __webpack_public_path__ + "static/media/29EUNOG1.116a4885.jpg";